<div
  class="inner-addon no-rel left-addon search-container"
  [ngClass]="{'opened-bar': openedSearchBar && !mobileMode, 'mobile-close-searchbar': mobileMode && !openedSearchBar, 'mobile-view': mobileMode}"
  (clickOutside)="closeSearchBar()"
  appClickOutsideComponent>
  <nb-icon
    icon="search"
    pack="icomoon"
    class="glyphicon"
    [ngClass]="{'mobile-icon' : mobileMode && openedSearchBar, 'hide-icon': mobileMode && !openedSearchBar, 'd-none': mobileMode && !openedSearchBar, 'hide': searchInput}"></nb-icon>
  <nb-icon icon="search" pack="icomoon" class="glyphicon glyphicon-mobile" [ngClass]="{'d-none': mobileMode && openedSearchBar || !mobileMode}"></nb-icon>
  <div class="click-to-close-area" *ngIf="openedSearchBar" (click)="closeSearchBar()"></div>
  <input
    placeholder="{{ 'view_translations.' + placeholder | translate }}"
    class="form-control border-0 searchbar-input-field"
    [ngClass]="{'error' : searchInput.length > 0 && searchInput.length < 2, 'mobile-input': mobileMode}"
    [(ngModel)]="searchInput"
    (input)="checkInputLength()"
    (keyup.enter)="searchHandler()"
    (click)="openSearchBar()" />
  <nb-icon
    *ngIf="!mobileMode || mobileMode && openedSearchBar"
    icon="basket-filled"
    pack="icomoon"
    class="basket-icon"
    [ngClass]="{'show' : searchInput.length !== 0}"
    (click)="clearSearchInput()"></nb-icon>
  <!--  <div-->
  <!--    *ngIf="!mobileMode || mobileMode && openedSearchBar"-->
  <!--    [ngClass]="{'show' : searchInput.length > 0 && searchInput.length < 2}"-->
  <!--    ngbTooltip="{{ 'view_translations.min_length_2' | translate }}"-->
  <!--    placement="top"-->
  <!--    container="body"-->
  <!--    class="info-icon-container">-->
  <!--    <nb-icon icon="info" pack="icomoon"></nb-icon>-->
  <!--  </div>-->
</div>
